import { FileRecord, UOMS } from '@amzn/awscat-portfolio-assessment-types';
import React from 'react';

export const RecordColCell = (item: FileRecord, property: string, webUOM?: UOMS) => {
    let value = item[property];
    if (typeof value === 'boolean') {
        value = value ? 'True' : 'False';
    }
    if (Array.isArray(value)) {
        value = value.join(', ');
    }

    if (value && webUOM) {
        value = Number(value).toLocaleString(undefined, {maximumFractionDigits: 2}) + ' ' + (webUOM === UOMS.PERCENTAGE ? '%' : webUOM);
    }

    return (<div>{value}</div>);
};
